<template lang="pug">
.layer.allow-replication(@click.self='handle', v-if='visiable', :class='[class_rel]')
  .content(:class='{ center: iscenter }' :style='{maxWidth: maxWidth}')
    div(v-if='type')
      i.iconfont.toast(v-if='type === "success"', :class='type') &#xe644;
      i.iconfont.toast(v-else, :class='type') &#xe6b3;
    i.iconfont.close(v-if='showClose', @click.self='handle') &#xe60a;
    div
      slot
        p.title(v-if='!useHtml') {{ title }}
        p.desc(v-if='!useHtml') {{ desc }}
        p.title(v-if='useHtml', v-html='title')
        p.desc(v-if='useHtml', v-html='desc')
    .button(v-if='showButton && cancelInLeft')
      kmbutton.diaKmButton(@click='cancel', v-if='showCancelButton', :isBorder='true') {{ cancelTxt }}
      kmbutton.diaKmButton(@click='confirm', :isBack='true') {{ confirmTxt }}
    .button(v-if='showButton && !cancelInLeft')
      kmbutton.diaKmButton(@click='confirm', :isBorder='true') {{ confirmTxt }}
      kmbutton.diaKmButton(@click='cancel', v-if='showCancelButton', :isBack='true') {{ cancelTxt }}
</template>

<script>
import Kmbutton from '../button/main'
export default {
  components: { Kmbutton },
  methods: {
    close() {
      this.callbackOnly()
      this.$destroy()
      this.$el.parentElement.removeChild(this.$el)
    },
    confirm() {
      this.callback()
      this.close()
    },
    cancel() {
      this.cancelCall()
      this.close()
    },
    handle() {
      if (this.closeOnClickModal) {
        this.distinguishCancelAndClose ? this.close() : this.cancel()
      }
    }
  },
  data() {
    return {
      callbackOnly: () => {},
      cancelCall: '',
      callback: '',
      confirmTxt: '',
      cancelTxt: '',
      iscenter: '',
      showButton: '',
      cancelInLeft: true,
      type: '',
      title: '',
      desc: '',
      useHtml: false,
      showClose: true,
      closeOnClickModal: true,
      showCancelButton: '',
      visiable: '',
      class_rel: '123',
      distinguishCancelAndClose: true,
      maxWidth: 'inherit',
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.visiable = true
    })
  }
}
</script>
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
.layer {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10010;
  .close {
    position: absolute;
    font-size: 20px;
    top: 6px;
    right: 6px;
    cursor: pointer;
  }
  background: rgba(0, 0, 0, 0.6);
  .content {
    background: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-height: 220px;
    min-width: 360px;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .content.center {
    text-align: center;
  }
  .button {
    display: flex;
    margin-top: 20px;
    justify-content: center;
  }
  i.success {
    color: #21bd73;
  }
  i.error {
    color: #ff6666;
  }
  i.warn {
    color: wheat;
  }
  i.toast {
    font-size: 60px;
  }
  i.confirm {
    display: none;
  }
  .title {
    min-height: 30px;
    font-size: 18px;
    color: #333;
  }
  .desc {
    margin-top: 20px;
    font-size: 16px;
    color: #666;
    min-height: 30px;
  }
  .diaKmButton {
    margin: 0 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/ui/components/messagebox/main.vue